import { render } from "./CoBrandArch.vue?vue&type=template&id=19c726fb&scoped=true"
import script from "./CoBrandArch.vue?vue&type=script&lang=js"
export * from "./CoBrandArch.vue?vue&type=script&lang=js"

import "./CoBrandArch.vue?vue&type=style&index=0&id=19c726fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c726fb"]])

export default __exports__